// Renew only while this app session is current. The server epoch is the
// authority; this timer and Crisp's mutable metadata never grant access.
export class SupportContextLease {
  constructor({ bind, readSession, onRejected = () => {}, now = () => Date.now(), every = fn => window.setInterval(fn, 1000), cancel = id => window.clearInterval(id) }) {
    Object.assign(this, { bind, readSession, onRejected, now, every, cancel })
    this.generation = 0
  }

  stop() {
    this.generation++
    if (this.timer !== undefined) this.cancel(this.timer)
    this.timer = undefined
  }

  start(token, isCurrent) {
    this.stop()
    const generation = this.generation
    let busy = false, nextAttempt = 0, lastSession = null
    const tick = async () => {
      if (busy || generation !== this.generation || !isCurrent()) return
      let session
      try { session = this.readSession() } catch (e) { return }
      if (!/^session_[a-f0-9-]{36}$/.test(session || "")) return
      if (session === lastSession && this.now() < nextAttempt) return
      busy = true
      lastSession = session
      nextAttempt = this.now() + 30000
      try {
        const result = await this.bind(token, session)
        if (generation === this.generation && isCurrent() && result && result.disabled === true) {
          this.stop()
          return
        }
        if (generation === this.generation && isCurrent()) nextAttempt = this.now() + 60000
      } catch (error) {
        const status = error && error.response && error.response.status
        if (generation === this.generation && isCurrent() && [401, 403].includes(status)) {
          this.stop()
          // Support eligibility is independent of the operator conversation.
          // The server denies account data; preserve the existing Crisp chat.
          this.onRejected(token, error)
        }
      } finally { busy = false }
    }
    this.timer = this.every(tick)
    tick()
  }
}
